import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { PriceHelper } from "../../Lib/Helper/PriceHelper";
import { AxLimeStone } from "../../Limestone/AxLimeStone";
import { CultureInfo } from "../../Models/Culture/CultureInfo";

@ModuleName("Eguma")
export class Eguma implements AxInit {
    constructor(private _AxLimestone = new AxLimeStone()) { }

    private PriceHelper: PriceHelper;

    AxInit(init: EgumaInitData): void {
        this.PriceHelper = new PriceHelper(init.CultureInfo, false);

        $('#kt_portlet__resort_charge').on('click', '.btn_payment__eguma-redeem', x => {
            let egumaVoucher = $('.payment__eguma-voucher').val();
            this._AxLimestone.LockButton(x.currentTarget);

            AxessViewer.loadPartialView('/Eguma/CheckEgumaVoucher/' + egumaVoucher, {}, (resp: EgumaBalanceResult) => {
                $('.payment__eguma-form ~ .ax-form-group-assistence').html('');

                if (resp.IsRedeemable) {
                    $('.payment__eguma-value').html(this.PriceHelper.GetPriceString(this.PriceHelper.GetPrice(resp.BalanceInCents)));
                } else {
                    $('.payment__eguma-value').html(this.PriceHelper.GetPriceString(this.PriceHelper.GetPrice(0)));
                }
                $('.payment__bank-value').html(this.PriceHelper.GetPriceString(this.PriceHelper.GetPrice(resp.RestAmount)));
                if (resp.Message) {
                    $('.payment__eguma-form ~ .ax-form-group-assistence').html(resp.Message);
                    $('.payment__eguma-form ~ .ax-form-group-assistence').toggleClass('success', resp.IsRedeemable);
                }
                this._AxLimestone.UnlockButton(x.currentTarget);
            }, {});
        });
    }
}

interface EgumaInitData {
    CultureInfo: CultureInfo
}

interface EgumaBalanceResult {
    Code: string;
    BalanceInCents: number;
    TotalAmountInCents: number;
    Message: string;
    IsRedeemable: boolean;
    RestAmount: number;
}